import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { ClientMainPanelComponent } from "./components/client-main-panel/client-main-panel.component";
import { ClientSessionComponent } from "./components/client-session/client-session.component";
import { ClientApplicationsComponent } from "./components/client-applications/client-applications.component";
import { WebClientSessionComponent } from "./components/web-client-session/web-client-session.component";

const routes: Routes = [
  {
    path: "Client Sessions",
    component: ClientMainPanelComponent,
    children: [
      { path: "sessions", component: ClientSessionComponent },
      { path: "webapp/sessions", component: WebClientSessionComponent },
      { path: "desktopapp/sessions", component: ClientSessionComponent },
      { path: "applications", component: ClientApplicationsComponent },
      { path: "", redirectTo: "sessions", pathMatch: "full" },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class DesktopClientRoutingModule {}
